import { render, staticRenderFns } from "./CustomilyPlanCard.vue?vue&type=template&id=666f9507&scoped=true"
import script from "./CustomilyPlanCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomilyPlanCard.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./CustomilyPlanCard.vue?vue&type=style&index=0&id=666f9507&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666f9507",
  null
  
)

export default component.exports